import {
  mergeFormWithSelectedTrailers,
  mergeFormWithTractor,
} from '@contracts/order/OrderForm';
import type { CheckedFields } from '@src/orders/domain/CheckedFields';
import { TractorIdField } from '@src/permitField/TractorInformationFields';
import type { Tractor } from '@src/tractor/domain/Tractor';
import type { TrailerListing } from '@src/trailer/domain/TrailerList';
import merge from 'lodash/merge';

export const PrefilledForm = ({
  currentEntries,
  currentFields,
  trailers,
  tractors,
}: {
  currentEntries: Record<string, unknown>;
  currentFields: CheckedFields;
  trailers: TrailerListing[];
  tractors: Tractor[];
}) => {
  const withPrefilledTractor = mergeFormWithSelectedTractor(
    currentEntries,
    currentFields,
    tractors,
  );
  return mergeFormWithSelectedTrailers(
    withPrefilledTractor,
    currentFields,
    trailers,
    merge,
  );
};

function mergeFormWithSelectedTractor(
  form: Record<string, unknown>,
  fields: string[],
  tractors: Tractor[],
): Record<string, unknown> {
  const selectedTractor = tractors.find(
    (tractor) => tractor.id === form[TractorIdField.fieldName],
  );

  if (!selectedTractor) {
    return form;
  }

  return mergeFormWithTractor(form, fields, selectedTractor, merge);
}
